module.exports = __webpack_public_path__ + "img/m-item09.8890779.png";